export const ANALYTICS_SEGMENT_ENABLED = 'analytics_segment_web';
